const ORGANIC = 0;
const PAID = 1;

export default {
    ORGANIC,
    PAID,
};
